import { useState } from "react";

import { ILayoutSupplier, ILayout } from "../../CreateWorkspaces";
import { Chip, Layout, LayoutTitle, StyledInputLabel, StyledSelect, StyledTextField, Subheader, Title, Typography } from "./styled";
import { LayoutSetupConfig } from "./LayoutSetupConfig";
import { Select, TextField } from "v2/components";
import { FormControl, InputAdornment, MenuItem } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface IProps {
  layouts: ILayoutSupplier[];
  handleUpdateLayouts: (payload: ILayout, allowed: { title: string, id: string }) => void;
}

export function LayoutSetup({ layouts, handleUpdateLayouts }: IProps) {
  const [selectedSupplier, setSelectedSupplier] = useState("TODOS");
  const [selectedFormat, setSelectedFormat] = useState("TODOS");
  const [search, setSearch] = useState("");

  const [selectedLayout, setSelectedLayout] = useState<ILayout | null>(null);

    function handleUnselectLayout() {
        setSelectedLayout(null);
    }

  return (
    <>
      {!selectedLayout && (
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Title>
              Selecione um template para configurar as atividades do contrato
            </Title>
            <Typography>
              Por favor, selecione um dos templates abaixo
            </Typography>
          </div>
          <StyledTextField
            value={search}
            placeholder="Pesquisar"
            label="Layouts"
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    color="action"
                    style={{ width: "24px", aspectRatio: "1" }}
                  />
                </InputAdornment>
              ),
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              marginBottom: "20px",
            }}
          >
          <FormControl style={{ width: "230px" }} >
            <StyledInputLabel id="tipo-supplier">Operadora</StyledInputLabel>
            <StyledSelect
              labelId="tipo-supplier"
              value={selectedSupplier}
              onChange={(e) => setSelectedSupplier(e.target.value as string)}
              style={{ height: "55.3px", marginBottom: "2.7px" }}
            >
              {layouts.map(layout => <MenuItem key={layout.name} value={layout.name}>{layout.name}</MenuItem>)}
              <MenuItem value="TODOS">Todos</MenuItem>
            </StyledSelect>
          </FormControl>
          <FormControl style={{ width: "230px" }} >
            <StyledInputLabel id="tipo-format">Formato de layout</StyledInputLabel>
            <StyledSelect
              labelId="tipo-format"
              value={selectedFormat}
              onChange={(e) => setSelectedFormat(e.target.value as string)}
              style={{ height: "55.3px", marginBottom: "2.7px" }}
            >
              <MenuItem value="TODOS">Todos</MenuItem>
              <MenuItem value="xlsx">xlsx</MenuItem>
            </StyledSelect>
          </FormControl>
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            {layouts.filter(layoutSupplier => selectedSupplier === "TODOS" ? true : layoutSupplier.name === selectedSupplier).map((layoutSupplier) => (
              <>
                <Subheader>{layoutSupplier.name}</Subheader>
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "24px" }}
                >
                  {layoutSupplier.layouts.filter(layout => selectedFormat === "TODOS" ? true : layout.formats.includes(selectedFormat)).filter(layout => !search ? true : layout.productType.toLowerCase().includes(search)).map((layout) => (
                    <Layout onClick={() => setSelectedLayout(layout)}>
                      <LayoutTitle>{layout.productType}</LayoutTitle>
                      <Chip label={layout.formats.join(", ")} variant="outlined" />
                      {layout.isConfigured ? (
                        <Chip
                            label="Ativo"
                            variant="filled"
                            style={{
                                backgroundColor: "#07e71213",
                                opacity: "0.8",
                                color: "#2E7D32",
                            }}
                        />
                      ) : (
                        <Chip label="Não configurado" variant="filled" />
                      )}
                    </Layout>
                  ))}
                </div>
              </>
            ))}
          </div>
        </>
      )}
      {selectedLayout && <LayoutSetupConfig title={layouts.find(la => la.layouts.find(l => l.id === selectedLayout.id))?.name ?? ""} layout={selectedLayout} handleUnselectLayout={handleUnselectLayout} handleUpdateLayouts={handleUpdateLayouts} />}
    </>
  );
}
